import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Generates a complete story using Firebase Cloud Function
 * @param {string} sourceStory - The source story provided by the user
 * @param {('Rhyming Story'|'Adventure Narrative'|'Poetic Prose'|'Diary or Journal as internal monolog')} writingStyle - The desired writing style
 * @param {number} wordsPerPage - Number of words per page (50 or 150)
 * @param {number} totalPages - Total number of pages
 * @param {string} bookId - The ID of the book
 * @returns {Promise<Object>} The generated story response
 */
export const generateWholeStory = async (
  sourceStory,
  wordsPerPage,
  totalPages,
  writingStyle,
  bookId
) => {
  try {
    console.log('Calling generateWholeStory with:', {
      sourceStory,
      wordsPerPage,
      totalPages,
      writingStyle,
      bookId
    });

    const functions = getFunctions();
    const generateStoryFunction = httpsCallable(functions, 'generateWholeStory');

    const response = await generateStoryFunction({
      sourceStory,
      wordsPerPage,
      totalPages,
      writingStyle,
      bookId
    });

    return response.data;
  } catch (error) {
    console.error('Error generating story:', error);
    throw error;
  }
};
